import React, { CSSProperties } from 'react'
import { PollTag } from '../../domain'
import {
  AnimalRights,
  Audit,
  DefenceSecurity,
  Environment,
  Equality,
  HumanRights,
  Lobbying,
  Management,
  Other,
} from './images'

interface Props {
  tagId: string
  style?: CSSProperties
}

export const TagIcon: React.FC<Props> = ({ tagId, style }) => {
  const initialStyle: CSSProperties = {
    width: '2rem',
    height: '2rem',
    objectFit: 'contain',
    ...style,
  }
  switch (tagId) {
    case PollTag.Other:
      return <Other style={initialStyle} />
    case PollTag.Equality:
      return <Equality style={initialStyle} />
    case PollTag.AnimalWelfare:
      return <AnimalRights style={initialStyle} />
    case PollTag.Audit:
      return <Audit style={initialStyle} />
    case PollTag.DefenceSecurity:
      return <DefenceSecurity style={initialStyle} />
    case PollTag.Environment:
      return <Environment style={initialStyle} />
    case PollTag.HumanRights:
      return <HumanRights style={initialStyle} />
    case PollTag.Lobbying:
      return <Lobbying style={initialStyle} />
    case PollTag.Management:
      return <Management style={initialStyle} />
    default:
      return <Other style={initialStyle} />
  }
}
